import React from 'react';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Sidebar from './components/Layout/Sidebar';
import SEO from './components/SEO/SEO';
import AppRoutes from './routes/Routes';
import AdBanner from './components/AdBanner/AdBanner';
import HelpButton from './components/UI/HelpButton';
import FloatingHelpButton from './components/UI/FloatingHelpButton';
import { SeoProvider } from './context/SeoContext';
import { ThemeProvider } from './context/ThemeContext';
import { DataProvider } from './context/DataContext';
import './assets/styles/global.css';
import './styles/themes.css';

function App() {
  // Conteúdo do botão de ajuda flutuante
  const helpContent = (
    <>
      <p>Bem-vindo à Calculadora de Juros Compostos!</p>
      <p>Esta ferramenta permite calcular o crescimento de investimentos ao longo do tempo utilizando o poder dos juros compostos.</p>
      <h3>Como usar:</h3>
      <ol>
        <li><strong>Calculadora:</strong> Insira seus valores iniciais e veja o crescimento do seu investimento</li>
        <li><strong>Cenários:</strong> Compare diferentes taxas de juros para otimizar seu investimento</li>
        <li><strong>Marcos:</strong> Defina objetivos financeiros e descubra quanto tempo levará para alcançá-los</li>
        <li><strong>Aposentadoria:</strong> Planeje sua independência financeira e aposentadoria</li>
        <li><strong>Exportar:</strong> Salve ou imprima os resultados para referência futura</li>
      </ol>
      <p>Em cada etapa você encontrará botões de ajuda específicos com mais informações.</p>
    </>
  );

  return (
    <SeoProvider>
      <ThemeProvider>
        <DataProvider>
          <div className="app-container">
            <SEO />
            <Header />
            <AdBanner 
              slot="1234567890" 
              format="auto" 
              responsive={true} 
              position="top"
            />
            <div className="content-wrapper">
              <main className="main-content">
                <AppRoutes />
              </main>
              <Sidebar />
            </div>
            <AdBanner 
              slot="0987654321" 
              format="auto" 
              responsive={true} 
              position="bottom"
            />
            <Footer />
            <HelpButton />
            <FloatingHelpButton 
              title="Guia da Calculadora"
              content={helpContent}
            />
          </div>
        </DataProvider>
      </ThemeProvider>
    </SeoProvider>
  );
}

export default App;